import produce from 'immer'
import { combineReducers } from 'redux'
import {
  getAllModemTypesAction,
  getModemTypeAction,
} from '../actions/modemTypesActions'

const byId = (state = {}, action) =>
  produce(state, draft => {
    const { type, payload } = action

    switch (type) {
      case getAllModemTypesAction.SUCCESS:
        payload.items.forEach(modemType => {
          draft[modemType.id] = modemType
        })
        break
    }
  })

const visibleIds = (state = [], action) =>
  produce(state, draft => {
    switch (action.type) {
      case getAllModemTypesAction.SUCCESS:
        draft.splice(
          0,
          draft.length,
          ...action.payload.items.map(modemType => modemType.id)
        )
        break
    }
  })

const meta = (state = {}, action) =>
  produce(state, draft => {
    switch (action.type) {
      case getAllModemTypesAction.SUCCESS:
        Object.assign(draft, action.payload.meta)
        break
    }
  })

// replaced rather than merged, so switching between modem types never
// leaves the previous one's carriers/countries behind
const current = (state = {}, action) => {
  switch (action.type) {
    case getModemTypeAction.SUCCESS:
      return action.payload
    default:
      return state
  }
}

const modemTypesReducer = combineReducers({
  byId,
  visibleIds,
  current,
  meta,
})

const getModemType = (state, id) => state.byId[id]
const getCurrentModemType = state => state.current
const getVisibleModemTypes = state =>
  state.visibleIds.map(id => getModemType(state, id))
const getModemTypesMeta = state => state.meta

export {
  modemTypesReducer as default,
  getCurrentModemType,
  getVisibleModemTypes,
  getModemTypesMeta,
}
